import { APP } from 'config';
import { AppLanguage, appLanguages } from 'types/general';
import { includes } from 'utils/general';

export const formatDuration = (
  language: string,
  duration: number,
  unit: 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year',
): string => {
  const locale: AppLanguage = includes(appLanguages, language)
    ? language
    : APP.locales.default;

  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unitDisplay: 'long',
    unit,
  }).format(duration);
};
